const idCardTypePH = {
  taxpayerIdentificationNumber: 'Nombor Pengenalan Pembayar Cukai',
  socialSecuritySystem: 'Sistem Keselamatan Sosial',
  governmentServiceInsuranceSystem: 'Sistem Insurans Perkhidmatan Kerajaan',
};

export default idCardTypePH;
